import * as Yup from "yup";
import form from "layouts/pages/home/components/Settings/schemas/form";
import { addPhoneValidationToYup } from "helpers/common";

const {
  formField: { firstName, lastName, email, mobile, phone, roleId },
} = form;

addPhoneValidationToYup(Yup);

const validations = Yup.object().shape({
  [firstName.name]: Yup.string().required(firstName.errorMsg),
  [lastName.name]: Yup.string().required(lastName.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [mobile.name]: Yup.number()
    .nullable()
    .max(99999999999, mobile.invalidMsg)
    .min(1000000000, mobile.minimumMsg),
  [phone.name]: Yup.string().phone().required(phone.errorMsg),
  // .required(phone.errorMsg),
  // .max(99999999, phone.invalidMsg)
  // .min(1000000, phone.minimumMsg),
  [roleId.name]: Yup.string().required(roleId.errorMsg),
});

export default validations;
